if (document.querySelector('.main-front-page')) {
    const listProyects = document.querySelectorAll('.proyects__data--li'),
        responseProyects = document.querySelectorAll('.proyects__pictures--li');
    listProyects[0].classList.add('active');
    responseProyects[0].classList.add('active');
    listProyects.forEach((item, index) => {
        item.addEventListener('click', () => {
            listProyects.forEach(item => {
                item.classList.remove('active');
            });
            item.classList.add('active');
            responseProyects.forEach(proyect => {
                proyect.classList.remove('active');
            });
            responseProyects[index].classList.add('active');
        })
    });
}